import { Spinner } from '@/app/ui/spinner';

const Loading = ({ height = 250, className = '', dataTestId }) => {
  return (
    <div className={`flex items-center justify-center ${className}`} style={{ height: `${height}px` }} data-testid={dataTestId}>
      <Spinner className="size-6" />
    </div>
  );
};

const LinearLoading = () => {
  return (
    <div className="relative overflow-hidden w-full h-full min-h-1">
      <div className="absolute w-full h-1 bg-primary/30 ">
        <div className="bg-primary/70 h-1 origin-left animate-progress z-1 " />
      </div>
    </div>
  );
};

export { Loading, LinearLoading };
